// @flow
import VueScrollTo from 'vue-scrollto'

export default {
  methods: {
    focusElementIfFound (elementId: string) {
      const element = document.getElementById(elementId)

      if (element) {
        element.focus()
      }
    },
    blurElementIfFound (elementId: string) {
      const element = document.getElementById(elementId)

      if (element) {
        element.blur()
      }
    },
    startScrollIntoView (duration: number = 300, $el: ?HTMLElement = null, options: Object = {}) {
      this._cancelScrollIntoView = VueScrollTo.scrollTo(
        $el || this.$el,
        duration,
        {...options, offset: (options['offset'] || 0) + computeCurrentOffset()}
      )
    },
    cancelScrollIntoView () {
      this._cancelScrollIntoView && this._cancelScrollIntoView()
    }
  }
}

function computeCurrentOffset () {
  const $content: ?HTMLElement = window.document.querySelector('.content')

  if ($content) {
    return -$content.offsetTop
  }

  return 0
}



// WEBPACK FOOTER //
// ./src/mixins/focus.js